import { getFromLocal } from "../utils/Cache";
import { organizationIds } from "./constants";

export function getAuthOptions(isFormData?: boolean) {
  const auth: any = getFromLocal("auth");
  const token = auth && auth.auth ? auth.auth.token || "" : "";
  let headers: any = {
    Authorization: `Bearer ${token}`,
  };
  if (isFormData) headers["Content-Type"] = "multipart/form-data";
  return { headers };
}

// export function getAuthOptionsWithOrganization(
//   isFormData?: boolean,
//   userId: string = ""
// ) {
//   const auth: any = getFromLocal("auth");
//   const token = auth && auth.auth ? auth.auth.token || "" : "";
//   let headers: any = {
//     Authorization: `Bearer ${token}`,
//     organizationId: organizationIds[1].id,
//   };
//   if (isFormData) headers["Content-Type"] = "multipart/form-data";
//   if (userId) headers["userId"] = userId;
//   return { headers };
// }
